import React, { useState, useRef, useContext } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ContextMenu } from 'primereact/contextmenu'
import DrawerEquipmentOptions from './drawerEquipmentOptions'
import CancelIcon from '@mui/icons-material/Cancel'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Tooltip } from '@mui/material'
import { useTranslation } from "react-i18next"
import './utils.css'
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import { M_Table, M_ElementDrawer, M_Button, NavigateContext, M_MessageBoard, BufferService, LoadingContext, M_CheckBox, M_InputTextField, } from 'src/M_Components'
import { Settings } from '@mui/icons-material'


export default function TableEquipments({ value, setValue, shipmentArray, setShipmentArray, fillFields,
    shipmentIndex, setShipmentIndex, containerIndex, setContainerIndex, isView, isApprove, openDrawer,
    setOpenDrawer, selectedLine, setSelectedLine, reprovedRows, setReprovedRows, onReprove, extraValuesArray,
    toastMessages, EquipmentIndex, setEquipmentIndex, drawerName, setDrawerName, setEquipmentClass, bookingLine,
    draft, id, fieldsInDrawerEquipment, fieldsInDrawerShipment, isForSplit, onPassLine, color, secondColor }) {

    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bookingEquipmentService = new BufferService('bookingEquipment/move')
    const { t } = useTranslation()
    const passIsView = isView !== null ? isView : false
    const cm = useRef(null)
    const [line, setLine] = useState(null)
    const [selectedRows, setSelectedRows] = useState(reprovedRows)
    //* begin cell edit?
    const [cellOptions, setCellOptions] = useState(false)
    //* event information for cell editing
    const [editTarget, setEditTarget] = useState(null)
    const [openEquipmentDrawer, setOpenEquipmentDrawer] = useState(false)
    const [moveEquipmentData, setMoveEquipmentData] = useState()
    const [confirmMovement, setConfirmMovement] = useState(false)
    const [confirmDataMovement, setConfirmDataMovement] = useState(null)
    const [open, setOpen] = useState(false)
    const [openSocMessage, setOpenSocMessage] = useState(false)
    const [socData, setSocData] = useState(null)

    fieldsInDrawerEquipment = fieldsInDrawerEquipment ? fieldsInDrawerEquipment : []
    fieldsInDrawerShipment = fieldsInDrawerShipment ? fieldsInDrawerShipment : []

    const openDrawerFunc = () => {
        setOpenDrawer(true)
    }

    const closeDrawer = () => {
        setOpenDrawer(false)
        setSelectedLine(null)
    }

    const menuModel = [
        { label: 'Equipment Options', command: () => openDrawerFunc(selectedLine) },
        { separator: true },
        { label: 'Copy Line', command: () => copyLine(selectedLine) },
        { label: 'Delete Line', command: () => deleteRow(selectedLine) },
        { separator: true },
        { label: 'Copy Shipment', command: () => copyShipment(selectedLine) },
        { label: 'Delete Shipment', command: () => deleteShipment(selectedLine) }
    ]
    const modalApprove = [
        { label: 'Equipment Options', command: () => openDrawerFunc(selectedLine) }
    ]
    const columns = [
        { label: 'IMO', type: 'checkbox', code: 'IMO' },
        { label: 'Equipment Type', type: 'combobox' },
        { label: 'Cargo Description', type: 'textfield' },
        { label: 'Load Weight (KG)', type: 'textfield' },
        { label: 'Loading Date', type: 'date' },
        { label: 'SOC', type: 'checkbox', code: 'SOC' },
        { label: 'Reefer', type: 'checkbox', code: 'Reefer' },
        { label: 'Open Top/FLAT', type: 'checkbox', code: 'OpenTop' },
        { label: 'RORO', type: 'checkbox', code: 'RORO' },
    ]

    //* begin cell edit
    const cellDoubleClick = (e) => {
        setCellOptions(true)
        setEditTarget(e.index)
    }

    const linesStyleNewEquipment = {
        borderTop: '2px solid var(--color-green)',
        borderBottom: '2px solid var(--color-green)',
    }

    const checkboxValue = (rowData, code) => {
        if (rowData[code] === null) {
            return <span style={{ display: 'flex', backgroundColor: 'lightgrey', alignItems: 'center', justifyContent: 'space-around', height: '42px' }}></span>
        }
        if ((rowData.bookingEquipmentStatus === 'D' && code !== 'IMO') || (rowData.shipmentStatus === 'D' && code === 'IMO')) {
            return (
                <div style={{
                    display: 'flex',
                    backgroundColor: 'var(--color-grey)',
                    borderTop: ' 2px solid var(--color-red)',
                    borderBottom: ' 2px solid var(--color-red)',
                    borderRight: code === 'IMO' && '2px solid var(--color-red)',
                    borderTopRightRadius: code === 'IMO' && '5px',
                    borderBottomRightRadius: code === 'IMO' && '5px',

                    alignItems: 'center',
                    justifyContent: 'space-around',
                    flexDirection: 'column',
                    height: '42px'
                }
                }>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                        <M_CheckBox
                            disabled={true}
                            checked={rowData[code]}
                        />
                    </div>
                </div >
            )


        } else {
            if (code === 'Reefer' || code === 'OpenTop' || code === 'RORO' || ((isForSplit || passIsView) && code !== 'IMO')) {
                return (
                    <div style={
                        rowData?.shipmentChanged?.includes('bookingEquipmentId') ?
                            {
                                ...linesStyleNewEquipment,
                                paddingTop: '1px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-around',
                                minHeight: '60px',
                            } :
                            {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-around',
                                minHeight: '60px',
                            }}>
                        <M_CheckBox
                            checked={rowData[code]}
                            disabled={true}
                            color={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-blue)'}
                        />
                    </div>
                )
            } else {
                return (
                    <div style={
                        rowData?.shipmentChanged?.includes('bookingEquipmentId') && code !== 'IMO' ?
                            {
                                ...linesStyleNewEquipment,
                                paddingTop: '1px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-around',
                                minHeight: '60px',
                            } :
                            rowData?.shipmentChanged?.includes('ShipmentId') && code === 'IMO' ?
                                {
                                    ...linesStyleNewEquipment,
                                    borderRight: '2px solid var(--color-green)',
                                    borderTopRightRadius: '5px',
                                    borderBottomRightRadius: '5px',
                                    paddingTop: '7px',
                                    paddingBottom: '7px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                    minHeight: '60px',
                                }
                                :
                                code === 'IMO' && rowData?.shipmentChanged?.includes('ShipmentId') && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ?
                                    {
                                        ...linesStyleNewEquipment,
                                        borderRight: '2px solid var(--color-green)',
                                        borderTopRightRadius: '5px',
                                        borderBottomRightRadius: '5px',
                                        paddingTop: '7px',
                                        paddingBottom: '7px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                        minHeight: '60px',
                                    }

                                    :
                                    {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                        minHeight: '60px',
                                    }}>
                        <M_CheckBox
                            disabled={isForSplit || passIsView}
                            checked={rowData[code]}
                            onChange={(e) => editField(rowData, code, e.target.checked)}
                            color={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('ShipmentId') && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-blue)'}
                        />
                    </div>
                )
            }
        }
    }

    const dynamicColumns = columns.map((value, key) => {
        if (value.type === 'checkbox') {
            if (value.code === 'SOC' || value.code === 'Reefer' || value.code === 'OpenTop' || value.code === 'RORO') {
                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'pointer', paddingRight: '0px' }} field="EquipmentIndex" key={key} header={value.label} body={(e) => checkboxValue(e, value.code)}></Column>
            } else {
                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'pointer', paddingRight: '0px' }} field='Shipment' key={key} header={value.label} body={(e) => checkboxValue(e, value.code)}></Column>
            }
        }
        else {
            if (value.label === 'Load Weight (KG)') {
                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'text' }} key={key} field="EquipmentIndex" header={value.label} body={(data, options) => textInputNumbers(data, value.label, options)} />
            }
            if (value.label === 'Cargo Description') {
                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'text' }} key={key} field="EquipmentIndex" header={value.label} body={(data) => textInput(data, value.label)} />
            }
            if (value.label === 'Loading Date') {
                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'text' }} key={key} field="EquipmentIndex" header={value.label} body={(data) => textInputDate(data, value.label)} />
            }
            if (value.label === 'Equipment Type') {

                return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor, minWidth: '150px' }} style={{ cursor: 'inherit' }} key={key} field="EquipmentIndex" header={value.label} body={(data, options) => equipmentPlusButton(data, value.label, options)} />
            }
            return <Column headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} style={{ cursor: 'inherit' }} key={key} field={value.label} header={value.label} />
        }
    })

    const equipmentPlusButton = (rowData, code, options) => {
        if (rowData[code] === null) {
            return (
                <span style={{ display: 'flex', backgroundColor: 'lightgrey', alignItems: 'center', justifyContent: 'space-around', height: '42px' }}></span>
            )
        }
        if (rowData.bookingEquipmentStatus === 'D') {
            return (
                <span style={{
                    display: 'flex',
                    backgroundColor: 'var(--color-grey)',
                    borderTop: ' 2px solid var(--color-red)',
                    borderBottom: ' 2px solid var(--color-red)',
                    borderLeft: '2px solid var(--color-red)',
                    borderTopLeftRadius: '5px',
                    borderBottomLeftRadius: '5px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: '42px'
                }
                }>
                    <b>
                        {rowData.Prefix && rowData.Number && rowData.CheckDigit ? `${rowData.Prefix} ${rowData.Number} ${rowData.CheckDigit}` : ''}
                    </b>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                        <div style={{ fontSize: '.7em', position: 'relative', left: '-10px' }}>
                            {rowData.EquipmentTransportKey}
                        </div>
                        {rowData[code]}
                    </div>
                </span >
            )
        }
        return (

            <span style={{
                borderLeft: `${rowData?.shipmentChanged?.includes('bookingEquipmentId') && '2px solid var(--color-green)' || '0px'}`,
                borderTop: `${rowData?.shipmentChanged?.includes('bookingEquipmentId') && '2px solid var(--color-green)' || '0px'}`,
                borderBottom: `${rowData?.shipmentChanged?.includes('bookingEquipmentId') && '2px solid var(--color-green)' || '0px'}`,
                borderTopLeftRadius: '5px',
                borderBottomLeftRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                height: '100%',
                minHeight: '60px'
            }}>
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', flexDirection: 'column' }}>
                    <b>
                        {rowData.Number && rowData.CheckDigit ? `${rowData.Prefix} ${rowData.Number} ${rowData.CheckDigit}` : ''}
                    </b>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                        <div style={{ fontSize: '.7em', position: 'relative', left: '-10px' }}>
                            {rowData.EquipmentTransportKey}
                        </div>
                        {rowData[code]}
                    </div>
                </span>
                {!isForSplit && !isView ?
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
                        <div> </div>
                        <Tooltip title={t('MoveEquipment')}>
                            <AirlineStopsIcon className=' cursorPointer' style={{ color: 'var(--color-blue)', }} onClick={() => moveEquipment(rowData)} />
                        </Tooltip>
                    </div>
                    :
                    ''
                }
            </span>
        )
    }

    const moveEquipment = (data) => {
        setOpenEquipmentDrawer(true)
        setMoveEquipmentData(data)
    }

    const confirmMovementFunction = (data) => {
        setConfirmDataMovement(data)
        setOpenEquipmentDrawer(false)
        setConfirmMovement(true)
    }

    const onMoveEquipment = (data) => {
        setConfirmMovement(false)
        const tempDetails = {
            "BookingId": bookingLine?.Id || '00000000-0000-0000-0000-000000000000',
            "NewBookingId": data[0].Id,
            "BookingEquipment": {
                'Id': moveEquipmentData.bookingEquipmentId || '00000000-0000-0000-0000-000000000000',
                'LoadingDate': moveEquipmentData["Loading Date"],
                'SOC': moveEquipmentData["SOC"] === true ? 'Y' : 'N',
                'Brand': moveEquipmentData["Brand"],
                'Model': moveEquipmentData["Model"],
                'Chassis': moveEquipmentData["Chassis"],
                'IdEquipment': moveEquipmentData["EquipmentId"] || '00000000-0000-0000-0000-000000000000',
                'IdEquipmentType': moveEquipmentData["EquipmentTypeId"] || '00000000-0000-0000-0000-000000000000',
                'IdEquipmentOwnerAccount': null,
                'GoodsDetails': moveEquipmentData["Cargo Description"],
                'TransportDetails': moveEquipmentData["Load Weight (KG)"],
            },
            "Dimensions": [],
        }

        if (moveEquipmentData.DimensionsHeight || moveEquipmentData.DimensionsWidth || moveEquipmentData.DimensionsLength) {
            tempDetails.Dimensions = [
                {
                    Id: moveEquipmentData.DimensionsId || '00000000-0000-0000-0000-000000000000',
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || '00000000-0000-0000-0000-000000000000',
                    DimensionsWidth: moveEquipmentData.DimensionsWidth || 0,
                    DimensionsHeight: moveEquipmentData.DimensionsHeight || 0,
                    DimensionsLength: moveEquipmentData.DimensionsLength || 0,
                }
            ]
        }
        if (moveEquipmentData.Front || moveEquipmentData.Back || moveEquipmentData.Left || moveEquipmentData.Right || moveEquipmentData.Height) {
            tempDetails.Dimensions = [
                {
                    Id: moveEquipmentData.DimensionsFROId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'FRO',
                    DimensionsLength: moveEquipmentData.Front || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsBACId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'BAC',
                    DimensionsLength: moveEquipmentData.Back || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsLEFId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'LEF',
                    DimensionsLength: 0,
                    DimensionsWidth: moveEquipmentData.Left || 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsRIGId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'RIG',
                    DimensionsLength: 0,
                    DimensionsWidth: moveEquipmentData.Right || 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsOVEId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'OVE',
                    DimensionsLength: 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: moveEquipmentData.Height || 0,
                },
            ]
        }

        bookingEquipmentService.post(tempDetails).then(response => {
            ctx.setIsLoad(false)
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', response.response.data.Message || response.message)
                return
            }
            deleteRow(moveEquipmentData)
            setOpen(true)
            ctx.toastMessages('success', '', t("EquipmentMoved"))

        })
    }

    const textInput = (rowData, code) => {
        if (rowData.bookingEquipmentStatus === 'D') {
            return (
                <span style={{
                    display: 'flex',
                    backgroundColor: 'var(--color-grey)',
                    borderTop: ' 2px solid var(--color-red)',
                    borderBottom: ' 2px solid var(--color-red)',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    flexDirection: 'column',
                    height: '42px'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around'
                    }}>
                        {rowData[code]}
                    </div>
                </span>
            )
        }
        return <div
            style={rowData?.shipmentChanged?.includes('bookingEquipmentId') ?
                {
                    ...linesStyleNewEquipment,
                    minHeight: '60px',
                } :
                {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60px',
                }}
        >
            <M_InputTextField
                size={'auto'}
                margin={'10px'}
                padding={'0px'}
                paddingLeft={'5px'}
                disabled={isForSplit || passIsView}
                type="text"
                value={rowData[code]}
                onChange={(e) => editField(rowData, code, e.target.value)}
                color={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                disabledColor={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
            />
        </div>
    }

    const textInputNumbers = (rowData, code, options) => {
        if (rowData.bookingEquipmentStatus === 'D') {
            return (
                <span style={{ display: 'flex', backgroundColor: 'var(--color-grey)', borderTop: ' 2px solid var(--color-red)', borderBottom: ' 2px solid var(--color-red)', alignItems: 'center', justifyContent: 'space-around', flexDirection: 'column', height: '42px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                        {rowData[code]}
                    </div>
                </span>
            )
        }
        return <div
            style={rowData?.shipmentChanged?.includes('bookingEquipmentId') ?
                {
                    ...linesStyleNewEquipment,
                    minHeight: '60px',
                } :
                {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60px',
                }}
        >
            <M_InputTextField
                margin={'10px'}
                padding={'0px'}
                paddingLeft={'5px'}
                disabled={isForSplit || passIsView || rowData?.IsFromTransporter === true || rowData?.IsFromTransporter === "true" || rowData?.IsFromTransporter === 1}
                value={ctx.useComma ? rowData[code]?.toString()?.replaceAll('.', ',') : rowData[code]?.toString()?.replaceAll(',', '.') || ''}
                onChange={(e) => editField(rowData, code, e.target.value.toString().replaceAll(',', '.'))}
                type={'number'}
                color={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                disabledColor={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
            />
        </div>
    }

    const textInputDate = (rowData, code) => {
        if (rowData[code] === null) {
            return <span style={{ display: 'flex', backgroundColor: 'lightgrey', alignItems: 'center', justifyContent: 'space-around', height: '42px' }}></span>
        }
        if (rowData.bookingEquipmentStatus === 'D') {
            return (
                <span style={{ display: 'flex', backgroundColor: 'var(--color-grey)', borderTop: ' 2px solid var(--color-red)', borderBottom: ' 2px solid var(--color-red)', alignItems: 'center', justifyContent: 'space-around', flexDirection: 'column', height: '42px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                        {rowData[code]}
                    </div>
                </span>
            )
        }
        return <div
            style={rowData?.shipmentChanged?.includes('bookingEquipmentId') ?
                {
                    ...linesStyleNewEquipment,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60px',
                } :
                {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60px',
                }}
        >
            <M_InputTextField
                margin={'10px'}
                padding={'0px'}
                paddingLeft={'5px'}
                disabled={isForSplit || passIsView}
                type="date"
                value={rowData[code]}
                onChange={(e) => editField(rowData, code, e.target.value)}
                color={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                disabledColor={rowData?.shipmentChanged?.includes(code) && !rowData?.shipmentChanged?.includes('bookingEquipmentId') ? 'var(--color-yellow)' : 'var(--color-white)'}
            />
        </div>
    }

    const editField = (rowData, code, data) => {
        let tempObj = rowData
        if (typeof data === 'string' || data instanceof String) {
            data = data.toLocaleUpperCase()
        }

        if (code === 'SOC') {
            if (data === true && rowData?.Prefix || data === false && rowData?.Prefix) {
                setOpenSocMessage(true)
                setSocData({ rowData, data })
            } else {
                changeSOC(rowData, data)
            }
            return
        }
        tempObj[code] = data
        setValue(value.map(obj => {
            if (obj.id === rowData.id) {
                return tempObj
            }
            else return obj
        }))

        if (code === 'IMO' && data == true) {
            openDrawerFunc()
            setSelectedLine(tempObj)
            setDrawerName('Shipment Options')
        }
    }

    const changeSOC = (rowData, data, deleteEquipment) => {
        rowData = rowData ? rowData : socData?.rowData
        data = data ? data : data === false ? false : socData?.data

        if (data) {
            openDrawerFunc()
        }
        let tempObj = rowData
        if (deleteEquipment) {
            tempObj = {
                ...tempObj,
                SOC: data,
                Prefix: '',
                Number: '',
                CheckDigit: '',
                Tare: '',
                Payload: '',
                equipmentNumber: '',
            }
        } else {
            tempObj['SOC'] = data
        }
        setValue(value.map(obj => {
            if (obj?.EquipmentIndex === rowData?.EquipmentIndex) {
                if (deleteEquipment) {
                    return {
                        ...obj,
                        SOC: data,
                        Prefix: '',
                        Number: '',
                        CheckDigit: '',
                        Tare: '',
                        Payload: '',
                        equipmentNumber: ''
                    }
                }
                return { ...obj, SOC: data }
            } else {
                return obj
            }
        }))
        if (data) {
            setSelectedLine(tempObj)
            setDrawerName('Equipment Options')
        }
        setSocData(null)
    }

    const copyLine = (data) => {
        let tempEquipmentIndex = EquipmentIndex
        tempEquipmentIndex++
        const tempObj = {
            ...data,
            'ShipmentDetailsId': undefined,
            'bookingEquipmentId': undefined,
            'id': containerIndex,
            'EquipmentIndex': tempEquipmentIndex,
        }
        setContainerIndex(containerIndex + 1)
        setValue(prev => [...prev, tempObj])
        setEquipmentIndex(tempEquipmentIndex)
    }

    const copyShipment = (data) => {
        let tempContIndex = containerIndex
        let tempEquipmentIndex = EquipmentIndex
        tempEquipmentIndex++
        const tempArray = value.filter(obj => obj.Shipment === data.Shipment).map(obj => {
            const tempObj = {
                ...obj,
                'ShipmentId': null,
                'ShipmentDetailsId': null,
                'bookingEquipmentId': null,
                'Shipment': shipmentIndex,
                'id': tempContIndex,
                'EquipmentIndex': tempEquipmentIndex,
                'Equipment': 'yes',
            }
            tempContIndex++
            return tempObj
        })
        setContainerIndex(tempContIndex)
        setShipmentArray(prev => [...prev, shipmentIndex])
        setShipmentIndex(shipmentIndex + 1)
        setEquipmentIndex(tempEquipmentIndex)
        setValue(prev => [...prev, ...tempArray])
    }

    const deleteShipment = (data) => {
        setShipmentArray(shipmentArray.filter(shipment => shipment !== data.Shipment))
        const newValue = value.filter(obj => obj.Shipment !== data.Shipment)
        if (newValue.length === 0) setEquipmentClass([])
        setValue(newValue)
        fillFields()
    }

    const deleteRow = (data) => {
        if (value.filter(obj => obj.Shipment === data.Shipment).length === 1) {
            setShipmentArray(shipmentArray.filter(shipment => shipment !== data.Shipment))
        }
        const newValue = value.filter(obj => obj.EquipmentIndex !== data.EquipmentIndex)
        if (newValue.length === 0) {
            setEquipmentClass([])
        }
        setValue(newValue)
        return newValue
    }

    const newShipmentStyle = {
        borderTop: '2px solid var(--color-green)',
        borderBottom: '2px solid var(--color-green)',
        borderLeft: '2px solid var(--color-green)',
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
    }

    const subHeader = (data, options) => {
        if (data.shipmentStatus === 'D') {
            return (
                <span style={{
                    display: 'flex',
                    backgroundColor: 'var(--color-grey)',
                    borderTopLeftRadius: '5px',
                    borderBottomLeftRadius: '5px',
                    borderLeft: '2px solid var(--color-red)',
                    borderTop: ' 2px solid var(--color-red)',
                    borderBottom: ' 2px solid var(--color-red)',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    flexDirection: 'column',
                    height: `${getShipmentSize(data?.Shipment) || 42}px`
                }}>
                    <div style={{ display: 'flex', marginLeft: '5px', alignItems: 'baseline', justifyContent: 'space-around' }}>
                        <div className='image-text'>Shipment {data.Shipment}</div>
                    </div>
                </span>
            )
        }
        return (
            <div
                className='cursorDefault heightSubHeader'
                style={data?.shipmentChanged?.includes('ShipmentId') ? {
                    paddingLeft: '5px',
                    minWidth: '100px',
                    height: 'auto !important',
                    minHeight: '60px',
                    ...newShipmentStyle
                } : {
                    paddingLeft: '5px',
                    minWidth: '100px',
                    height: 'auto !important',
                    minHeight: '60px',
                }}
            >
                <div className='image-text'>Shipment {data.Shipment}</div>
                {isForSplit || isView ?
                    <>
                        <Tooltip title={t('shipmentOptions')}>
                            <Settings className=' cursorPointer' style={{ color: checkShipmentChangesDrawer(data) ? 'var(--color-yellow)' : 'var(--color-green)', transform: 'scale(.8)' }}
                                onClick={() => {
                                    openDrawerFunc()
                                    setSelectedLine(data)
                                    setDrawerName('Shipment Options')
                                }}
                            />
                        </Tooltip>
                    </>
                    :
                    <>
                        {!isApprove && <Tooltip title={t('copyShipment')}>
                            <ContentCopyIcon className=' cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => copyShipment(data)} />
                        </Tooltip>}
                        <Tooltip title={t('deleteShipment')}>
                            <CancelIcon className='buttonColorRed cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => deleteShipment(data)} />
                        </Tooltip>
                        <Tooltip title={t('shipmentOptions')}>
                            <Settings className=' cursorPointer' style={{ color: checkShipmentChangesDrawer(data) ? 'var(--color-yellow)' : 'var(--color-green)', transform: 'scale(.8)' }}
                                onClick={() => {
                                    openDrawerFunc()
                                    setSelectedLine(data)
                                    setDrawerName('Shipment Options')
                                }} />
                        </Tooltip>
                    </>
                }
            </div>
        )
    }

    const onSelectionChangeSplit = (e) => {
        let tempValue = []

        /*if (isSelectSingle) {
            tempValue = [e.value]
        } else {*/
        if (e.type === 'all') {
            if (e.value.length) {
                selectedRows.forEach(obj => {
                    if (!e.value.find(rowObj => rowObj.Id === obj.Id)) {
                        tempValue.push(obj)
                    }
                })
                tempValue.push(...e.value)
            } else {
                selectedRows.forEach(obj => {
                    if (!value.find(rowObj => rowObj.Id === obj.Id)) {
                        tempValue.push(obj)
                    }
                })
            }
        } else {
            tempValue = [...e.value]
        }

        onPassLine(tempValue)
        setSelectedRows([...tempValue])
    }

    const checkEquipmentChangesDrawer = (data) => {
        if (!data?.shipmentChanged?.includes('bookingEquipmentId'))
            return data?.shipmentChanged?.some(field => fieldsInDrawerEquipment.includes(field))
    }

    const checkShipmentChangesDrawer = (data) => {
        if (!data?.shipmentChanged?.includes('ShipmentId')) {
            const tempChanges = data?.shipmentChanged?.some(field => fieldsInDrawerShipment?.includes(field))
            if (tempChanges) {
                return tempChanges
            } else {
                const tempDangerGoods = data?.dangerousGoods?.some(obj => {
                    return obj?.shipmentChanged?.some(field => fieldsInDrawerShipment?.includes(field))
                })
                return tempDangerGoods
            }
        }
    }


    const buttonEquipment = (data) => {
        if (data.bookingEquipmentStatus === 'D') {
            return (
                <span style={{
                    display: 'flex',
                    backgroundColor: 'var(--color-grey)',
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                    borderTop: ' 2px solid var(--color-red)',
                    borderBottom: ' 2px solid var(--color-red)',
                    borderRight: '2px solid var(--color-red)',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    flexDirection: 'column',
                    height: '42px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}> </div>
                </span>
            )
        }
        return (
            <div
                style={
                    data?.shipmentChanged?.includes('bookingEquipmentId') ?
                        {
                            ...linesStyleNewEquipment,
                            borderRight: '2px solid var(--color-green)',
                            borderTopRightRadius: '5px',
                            borderBottomRightRadius: '5px',
                            paddingTop: '8px',
                            paddingBottom: '7px',
                            minHeight: '60px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }
                        : { minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }
                }
            >
                {isForSplit || isApprove || isView ?
                    <Tooltip title={t('equipmentOptions')}>
                        <Settings className='cursorPointer' style={{ color: checkEquipmentChangesDrawer(data) ? 'var(--color-yellow)' : 'var(--color-green)', transform: 'scale(.8)' }}
                            onClick={() => {
                                openDrawerFunc()
                                setSelectedLine(data)
                                setDrawerName('Equipment Options')
                            }} />
                    </Tooltip>
                    :
                    <>
                        <Tooltip title={t('deleteEquipment')}>
                            <CancelIcon className='buttonColorRed cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => deleteRow(data)} />
                        </Tooltip>
                        <Tooltip title={t('equipmentOptions')}>
                            <Settings className=' cursorPointer' style={{ color: checkEquipmentChangesDrawer(data) ? 'var(--color-yellow)' : 'var(--color-green)', transform: 'scale(.8)' }}
                                onClick={() => {
                                    openDrawerFunc()
                                    setSelectedLine(data)
                                    setDrawerName('Equipment Options')
                                }} />
                        </Tooltip>
                    </>
                }
            </div>
        )
    }

    const closeTab = () => {
        ctx2.closeTab(JSON.parse(id))
    }

    const continueBooking = () => {
        setOpen(false)
    }

    const getShipmentSize = (shipNr) => {
        let defaultsize = 42
        let size = 42

        const resultSize = value.filter(data => data.Shipment === shipNr).length

        size = (resultSize * defaultsize) + (resultSize - 1)

        return size
    }

    return (
        <>
            <div className='divPrincipalTable'>
                <div className='divTable' style={{ paddingBottom: '40px ' }}>
                    <ContextMenu model={isForSplit || isApprove || isView ? modalApprove : menuModel} ref={cm} onHide={() => { setLine(null) }} />
                    {passIsView ?
                        <DataTable
                            value={value}
                            groupRowsBy={["Shipment", "EquipmentIndex"]}
                            rowGroupMode="rowspan"
                            className='tableEquipments'
                            // showGridlines
                            editMode={isForSplit ? "" : "cell"}
                            size="small"
                            // contextMenuSelection={isApprove && selectedLine}
                            onContextMenuSelectionChange={e => {
                                setSelectedLine(e.value)
                            }}
                            onContextMenu={e => cm.current.show(e.originalEvent)}
                        >
                            <Column className='shipmentNameBooking' headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor, minWidth: '100px' }} field='Shipment' header='Shipment' body={subHeader} />
                            {dynamicColumns}
                            <Column field="EquipmentIndex" headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} className='' body={buttonEquipment} />
                        </DataTable>
                        :
                        <DataTable
                            value={value}
                            groupRowsBy={["Shipment", "EquipmentIndex"]}
                            rowGroupMode="rowspan"
                            className='tableEquipments'
                            size="small"
                            selectionMode={isForSplit ? "multiple" : ""}
                            // showGridlines
                            selection={isForSplit && selectedRows}
                            // contextMenuSelection={isApprove && selectedLine}
                            onSelectionChange={onSelectionChangeSplit}
                            onContextMenuSelectionChange={e => {
                                if (e.value.bookingEquipmentStatus === 'D') return
                                setSelectedLine(e.value)
                                setLine(e.value)
                            }}
                            onContextMenu={e => cm.current.show(e.originalEvent)}
                            onRowDoubleClick={isApprove ? (e) => { cellDoubleClick(e) } : null}
                        >
                            {isForSplit ?
                                <Column
                                    headerStyle={{
                                        borderBottom: `2px solid ${color}`,
                                        color: secondColor
                                    }}
                                    selectionMode="multiple" className='TableSelectionColumn' frozen></Column>
                                : ""
                            }

                            <Column className='shipmentNameBooking' headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor, minWidth: '100px' }} field='Shipment' header='Shipment' body={subHeader} />
                            {dynamicColumns}
                            <Column field="EquipmentIndex" headerStyle={{ borderBottom: `2px solid ${ctx.primaryColor}`, color: ctx.secondaryColor }} className='' body={buttonEquipment} />
                        </DataTable>
                    }
                </div>
            </div>
            <DrawerEquipmentOptions
                drawerName={drawerName}
                isView={isForSplit || isView}
                value={value}
                setValue={setValue}
                selectedLine={selectedLine}
                open={openDrawer}
                onClose={closeDrawer}
                setContainerIndex={setContainerIndex}
                extraValuesArray={extraValuesArray}
                toastMessages={toastMessages}
                EquipmentIndex={EquipmentIndex}
                setEquipmentIndex={setEquipmentIndex}
                shipmentIndex={shipmentIndex}
                setShipmentIndex={setShipmentIndex}
                shipmentArray={shipmentArray}
                setShipmentArray={setShipmentArray}
            />
            <M_ElementDrawer
                open={openEquipmentDrawer}
                setOpen={setOpenEquipmentDrawer}
                onClose={() => setOpenEquipmentDrawer(false)}
                element={
                    <>
                        <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{'Booking'}</h2>
                        <M_Table
                            entityName={'booking'}
                            useSessionStorage={false}
                            crud={false}
                            tableLabel={'Booking'}
                            entity={'booking'}
                            onPassLine={confirmMovementFunction}
                            FILTER={`Id ne ${bookingLine?.Id}`}
                        />
                    </>
                }
            />
            {/* CONFIRM CHANGING SOC */}
            <M_MessageBoard
                open={openSocMessage}
                onClose={() => setOpenSocMessage(false)}
                title={t('ConfirmSoc')}
                body={socData?.data ? t('socTrue') : t('socFalse')}
                footer={(
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonCancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setOpenSocMessage(false)
                                setSocData(null)
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonConfirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                changeSOC(socData?.rowData, socData?.data, true)
                                setOpenSocMessage(false)
                            }}
                        />
                    </div>
                )}
            />

            <M_MessageBoard
                open={confirmMovement}
                onClose={() => setConfirmMovement(false)}
                title={t('MoveEquipment')}
                body={<div>
                    {t("ConfirmEquipmentMoved")}
                    <div className="divGlobalTransferShipment">
                        <div className="ts-from-container">
                            <div className="ts-label">From</div>
                            <div className="ts-booking-number">
                                Booking {bookingLine?.BookingNumber}
                            </div>

                            <div className="ts-equipment-row">
                                <b className="ts-equipment-number">
                                    {moveEquipmentData?.equipmentNumber}
                                </b>
                                <span className="ts-equipment-type">
                                    {moveEquipmentData?.EquipmentType}
                                </span>
                            </div>
                        </div>
                        <div className="ts-arrow">
                            <img src="/icons/svgsDaNet/arrow-right.svg" alt="to" className="ts-arrow-img" />
                        </div>
                        <div className="ts-to-container">
                            <div className="ts-label">To</div>

                            <div className="ts-to-list">
                                {confirmDataMovement?.length ? confirmDataMovement.map((data, index) => (
                                    <div key={index} className="ts-to-pill">
                                        Booking {data.BookingNumber}
                                    </div>
                                )) :
                                    <div className="ts-empty">—</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>}
                footer={(
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Cancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setConfirmDataMovement(null)
                                setConfirmMovement(false)
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Confirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                ctx.setIsLoad(true)
                                onMoveEquipment(confirmDataMovement)
                            }}
                        />
                    </div>
                )}
            />
            <M_MessageBoard
                open={open}
                onClose={() => setOpen(false)}
                title={t('MoveEquipment')}
                body={t("EquipmentMoved")}
                footer={(
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('CloseTab')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { closeTab() }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Continue')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { continueBooking() }}
                        />
                    </div>
                )}
            />
        </>
    )
}